import { render, staticRenderFns } from "./PopupAttachmentButton.vue?vue&type=template&id=725fb3ef"
import script from "./PopupAttachmentButton.vue?vue&type=script&lang=js"
export * from "./PopupAttachmentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports